import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router";
import { SettingsProvider } from "@/components/settings/settings-provider";
import { Toaster } from "@/components/ui/sonner";
import { useLicenseRecheck } from "@/hooks/use-license";
import { CreateRoomPage } from "@/routes/create-room";
import { LandingPage } from "@/routes/landing";
import { ImprintPage, PrivacyPage } from "@/routes/legal";
import { LicenseSuccessPage } from "@/routes/license-success";
import { NotFoundPage } from "@/routes/not-found";
import { RoomPage } from "@/routes/room";

const queryClient = new QueryClient({
  defaultOptions: {
    // Rooms stay fresh through realtime events (hooks/use-room.ts), not polling.
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

function LicenseRecheck() {
  useLicenseRecheck();
  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SettingsProvider>
          <LicenseRecheck />
          <Routes>
            <Route index element={<LandingPage />} />
            <Route path="create-new" element={<CreateRoomPage />} />
            <Route path="room/:roomId" element={<RoomPage />} />
            <Route path="license/success" element={<LicenseSuccessPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="imprint" element={<ImprintPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </SettingsProvider>
      </BrowserRouter>
      <Toaster theme="dark" richColors position="top-right" />
    </QueryClientProvider>
  );
}
